import * as React from "react";

function IncomeIcon(props) {
  return (
    <svg viewBox="0 0 496 496" width="1em" height="1em" {...props}>
      <path d="M104 104c-8.824 0-16-7.176-16-16s7.176-16 16-16 16 7.176 16 16h16c0-17.648-14.352-32-32-32S72 70.352 72 88s14.352 32 32 32c8.824 0 16 7.176 16 16s-7.176 16-16 16-16-7.176-16-16H72c0 17.648 14.352 32 32 32s32-14.352 32-32-14.352-32-32-32z" />
      <path d="M96 40h16v24H96zM96 160h16v24H96zM0 448v48h144v-48H0zm128 32H16v-16h112v16z" />
      <path d="M0 416v48h144v-48H0zm128 32H16v-16h112v16z" />
      <path d="M0 384v48h144v-48H0zm128 32H16v-16h112v16zM208 448v16h80v16H176v-16h16v-16h-32v48h144v-48z" />
      <path d="M160 416v40h16v-24h112v24h16v-40z" />
      <path d="M160 384v48h144v-48H160zm128 32H176v-16h112v16z" />
      <path d="M160 352v48h144v-48H160zm128 32H176v-16h112v16z" />
      <path d="M160 320v48h144v-48H160zm128 32H176v-16h112v16zM320 448v48h144v-48H320zm128 32H336v-16h112v16z" />
      <path d="M320 416v48h144v-48H320zm128 32H336v-16h112v16z" />
      <path d="M320 384v48h144v-48H320zm128 32H336v-16h112v16z" />
      <path d="M320 352v48h144v-48H320zm128 32H336v-16h112v16z" />
      <path d="M432 320v16h16v16H336v-16h80v-16h-96v48h144v-48z" />
      <path d="M320 288v40h16v-24h112v24h16v-40z" />
      <path d="M320 256v48h144v-48H320zm128 32H336v-16h112v16zM376 0c-13.232 0-24 10.768-24 24s10.768 24 24 24h36.688l-117.84 117.848-63.368-39.608L3.056 305.656l9.888 12.584L232.52 145.768l64.632 40.392L451.312 32H376c-4.416 0-8-3.592-8-8s3.584-8 8-8h104v104c0 4.408-3.584 8-8 8s-8-3.592-8-8V52.688L302.608 214.072 231.192 174.4 27 337.752l10 12.496L232.808 193.6l72.584 40.328L448 91.312V120c0 13.232 10.768 24 24 24s24-10.768 24-24V0H376zM32 104h16v16H32zM160 104h16v16h-16z" />
      <path d="M104 8C46.656 8 0 54.656 0 112s46.656 104 104 104 104-46.656 104-104S161.344 8 104 8zm0 192c-48.52 0-88-39.48-88-88s39.48-88 88-88 88 39.48 88 88-39.48 88-88 88z" />
    </svg>
  );
}

const MemoIncomeIcon = React.memo(IncomeIcon);
export default MemoIncomeIcon;
